"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalysisScene = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reactHotLoader = require("react-hot-loader");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var routes = _interopRequireWildcard(require("../../utils/routes"));

var _navigate = require("../../utils/routes/navigate");

var _Monitoring = require("./Monitoring");

var _Insights = require("./Insights");

const mapStateToProps = state => ({
  appReady: state.appSetup.appSetupComplete
});

const Analysis = ({
  appReady
}) => {
  if (!appReady) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
    title: "Analysis"
  }), /*#__PURE__*/React.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/React.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: routes.ANALYSIS,
    to: (0, _navigate.getLinkTo)(routes.INSIGHTS)
  }), /*#__PURE__*/React.createElement(_reactRouterDom.Route, {
    path: routes.INSIGHTS,
    component: _Insights.InsightsScene
  })), /*#__PURE__*/React.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/React.createElement(_reactRouterDom.Route, {
    path: routes.MONITORING,
    component: _Monitoring.ConnectedMonitoring
  })));
};

const AnalysisScene = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps)(Analysis));
exports.AnalysisScene = AnalysisScene;